import React, { useEffect, useState } from 'react';
import { StickerCard } from '../ui/StickerCard';
import { useTutorial } from './TutorialProvider';
import { useTutorialTarget } from './useTutorialTarget';

export const DEMO_TARGET_ID = '__demo_sticker__';

export function DemoStickerStage() {
  const { currentStep, demoAction, state } = useTutorial();
  const ref = useTutorialTarget(DEMO_TARGET_ID);

  const initialCount =
    currentStep.kind === 'demo-sticker' ? currentStep.initialCount : 0;
  const [count, setCount] = useState(initialCount);

  useEffect(() => {
    if (currentStep.kind === 'demo-sticker') {
      setCount(currentStep.initialCount);
    }
  }, [currentStep, state.stepIndex]);

  if (currentStep.kind !== 'demo-sticker') return null;

  const handleClick = () => {
    setCount((c) => (c >= 99 ? 0 : c + 1));
    demoAction('click');
  };

  const handleLongPress = () => {
    setCount((c) => Math.max(0, c - 1));
    demoAction('longpress');
  };

  return (
    <div className="fixed inset-0 pointer-events-none" style={{ zIndex: 62 }}>
      <div
        className="absolute left-1/2 -translate-x-1/2 flex flex-col items-center"
        style={{ top: 'max(calc(env(safe-area-inset-top) + 12px), min(8vh, 90px))' }}
      >
        <span className="mb-2 inline-flex items-center bg-green-700 text-white px-3 py-1 rounded-pill shadow-md font-display font-semibold text-small leading-none">
          Figurinha do álbum
        </span>
        <span aria-hidden className="block w-px h-3 bg-green-700/40 mb-1" />
        <div
          ref={ref}
          className="pointer-events-auto scale-[1.3] md:scale-[1.5]"
          style={{ transformOrigin: 'center top' }}
        >
          <div
            className={
              currentStep.attentionPulse && count === currentStep.initialCount
                ? 'animate-attention-wiggle'
                : ''
            }
          >
            <StickerCard
              code="BRA1"
              count={count}
              size="lg"
              showCode
              onClick={handleClick}
              onLongPress={handleLongPress}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
